(function () {
    'use strict';

    angular.module('l4b').config(Router);

    function Router($stateProvider, Constants) {

        $stateProvider

            .state(Constants.Page.Login, {
                url: '/login',
                templateUrl: 'html/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                params: {
                    isSessionExpired: null,
                    tabSelected: null,
                    token: null
                }
            })

            .state(Constants.Page.PersonalInformation, {
                url: '/personalInformation?brand&token',
                templateUrl: 'html/personalInformation/personalInformation.html',
                controller: 'PersonalInformationController',
                controllerAs: 'vm',
                params: {
                    token: null,
                    brand: null
                }
            })

            .state(Constants.Page.ChildInformation, {
                url: '/childInformation?brand',
                templateUrl: 'html/childInformation/childInformation.html',
                controller: 'ChildInformationController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.IncomeEligibility, {
                url: '/incomeEligibility?brand',
                templateUrl: 'html/incomeEligibility/incomeEligibility.html',
                controller: 'IncomeEligibilityController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.InvalidAddress, {
                url: '/invalidAddress?brand',
                templateUrl: 'html/invalidAddress/invalidAddress.html',
                controller: 'InvalidAddressController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.ShippingAddress, {
                url: '/shippingAddress?brand',
                templateUrl: 'html/shippingAddress/shippingAddress.html',
                controller: 'ShippingAddressController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.ProgramEligibility, {
                url: '/programEligibility?brand',
                templateUrl: 'html/programEligibility/programEligibility.html',
                controller: 'ProgramEligibilityController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.BenefitSelection, {
                url: '/benefitSelection?brand',
                templateUrl: 'html/landing/benefitSelection.html',
                controller: 'BenefitSelectionController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.Landing, {
                url: '/landing',
                templateUrl: 'html/landing/landing.html',
                controller: 'LandingController',
                controllerAs: 'vm',
                params: {
                    token: null
                }
            })

            .state(Constants.Page.ApplicationCompleted, {
                url: '/applicationCompleted?brand',
                templateUrl: 'html/applicationCompleted/applicationCompleted.html',
                controller: 'ApplicationCompletedController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.Exit, {
                url: '/exit?brand',
                templateUrl: 'html/exitPage/exitPage.html',
                controller: 'ExitPageController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.Error, {
                url: '/error?brand',
                templateUrl: 'html/error/error.html',
                controller: 'ErrorController',
                controllerAs: 'vm',
                params: {
                    brand: null
                }
            })

            .state(Constants.Page.About, {
                url: '/about',
                controller: 'AboutController',
                templateUrl: 'html/about/about.html',
                controllerAs: 'vm'
            })
            
			.state(Constants.Page.TechnicalSupport, {
                url: '/technicalSupport',
                templateUrl: 'html/technicalSupport/technicalSupport.html',
                controller: 'SidePagesController',
                controllerAs: 'vm'
            })


            .state(Constants.Page.AboutUs, {
                url: '/aboutUs',
                templateUrl: 'html/aboutUs/aboutUs.html'
            })

            .state(Constants.Page.NatVerLanding, {
                url: '/natVerLanding/{data}?brand',
                templateUrl: 'html/natVerLanding/natVerLanding.html',
                controller: 'NatVerLandingController',
                controllerAs: 'vm',
                params: {
                    data: null,
                    brand: null
                }
            })

            .state(Constants.Page.EmailVerification, {
                url: '/emailVerification',
                templateUrl: 'html/emailVerification/emailVerification.html',
                controller: 'EmailVerificationController',
                controllerAs: 'vm',
                params: {
                    pinCodeExpired: false
                }
            })
            ;
		}
})();
